export class DistanceConverter {
	static toImperial(value: number): number {
		return (value / 1.609344);
	}

	static toMetric(value: number): number {
		return (value * 1.609344);
	}
}